module.exports = __webpack_public_path__ + "static/media/scroll4_phone1.9e33e521.png";